// extracted by css-extract-rspack-plugin
export default {"tooltip":"wifiTargeting_tooltip__AHDJI","prioritized":"wifiTargeting_prioritized__ANK2c"};